import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';

// Semantic flags for the results-page experiments, read once from the bag.

export const useResultsPageConfig = () => {
  var _getPremiumEssentials;
  const experiments = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.experiments;
  const isOn = spec => Boolean(experiments == null ? void 0 : experiments[spec]);
  return {
    isBmOptimized: isOn(ExperimentSpecs.ResultsPageOptimizationsBM),
    showExactMatchHeadline: isOn(ExperimentSpecs.ResultsPageExactMatchHeadline)
  };
};
//# sourceMappingURL=useResultsPageConfig.js.map